/** True when a URL/key is an Aadhaar scan, not a face photo. */
export function isAadhaarDocumentUrl(url) {
  const v = String(url || '').toLowerCase();
  return (
    v.includes('aadhaar_front') ||
    v.includes('aadhaar_back') ||
    v.includes('aadhaar-front') ||
    v.includes('aadhaar-back')
  );
}

/** Profile avatar only — empty if missing or if it is an Aadhaar image. */
export function profilePhotoOnly(url) {
  const value = String(url || '').trim();
  if (!value || isAadhaarDocumentUrl(value)) return '';
  return value;
}
